var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenReqDeSel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15482 21.3202H2.444C1.99594 21.3202 1.62934 20.9567 1.62934 20.5126V2.42274C1.62934 1.97857 1.99594 1.61516 2.444 1.61516H16.0761C16.5242 1.61516 16.8908 1.97857 16.8908 2.42274V9.16336C16.8908 9.61022 17.2547 9.97094 17.7054 9.97094C18.1562 9.97094 18.5201 9.61022 18.5201 9.16336V2.42274C18.5201 1.08754 17.423 0 16.0761 0H2.444C1.09709 0 0 1.08754 0 2.42274V20.5126C0 21.8478 1.09709 22.9353 2.444 22.9353H8.15482C8.60561 22.9353 8.96949 22.5746 8.96949 22.1277C8.96949 21.6809 8.60561 21.3202 8.15482 21.3202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75195 7.26831H13.4417",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84668 10.4985H12.1787",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84668 13.7288H9.19157",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84668 16.9592L8.35018 16.8785",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75195 3.49976H13.4417",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1076 14.8765H16.5547V18.2708L19.1111 20.805L20.208 19.7177L18.1076 17.6357V14.8765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0181 11.1577C14.1611 11.1577 11.0361 14.2576 11.0361 18.0789C11.0361 21.9002 14.1633 25.0002 18.0181 25.0002C21.875 25.0002 25 21.9002 25 18.0789C25 14.2576 21.8729 11.1577 18.0181 11.1577ZM18.0181 23.4649C15.0225 23.4649 12.587 21.0506 12.587 18.081C12.587 15.1115 15.0225 12.6972 18.0181 12.6972C21.0137 12.6972 23.4492 15.1115 23.4492 18.081C23.4492 21.0506 21.0116 23.4649 18.0181 23.4649Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenReqDeSel);
export default __webpack_public_path__ + "static/media/penReqDeSel.b39451efeec509319d35e374a9242253.svg";
export { ForwardRef as ReactComponent };